module.exports = __webpack_public_path__ + "static/media/pfg-background.ab93ebbf.jpg";